import { NavMenuDropdown } from 'hfs-common-ui';
import { useMemo } from 'react';
import { useUptimeNavigation } from 'core/hooks/use-uptime-navigation';
import useMediaQuery from 'core/hooks/use-media-query';
import { useAppSelector } from 'core/hooks/use-app-selector';
import { selectFeedbackUrl } from 'core/config/firebase/remote-config-slice';
import { device } from 'core/styles/variables';
import { testIds } from 'core/test-ids';
import { getDropdownMenu } from '../NavMenu/menu';

type Props = {
  isOpen?: boolean;
  onClick?: () => void;
};

const MenuWithDropdown = ({ isOpen, onClick }: Props) => {
  const isDesktop = useMediaQuery(device.lg);
  const unreadChangelogEntries = useAppSelector((state) => state.changelog.unreadWhatIsNewCount);
  const feedbackUrl = useAppSelector(selectFeedbackUrl);

  const dropdownMenu = useMemo(
    () => getDropdownMenu(isDesktop, unreadChangelogEntries, feedbackUrl),
    [isDesktop, unreadChangelogEntries, feedbackUrl]
  );
  const { activeDropdownMenu, onClickHandler } = useUptimeNavigation(dropdownMenu.menu, onClick);

  return (
    <div>
      {isOpen && (
        <NavMenuDropdown
          data-testid={testIds.core.menuWithDropdown}
          activeMenuItemId={activeDropdownMenu}
          onClick={onClickHandler}
          menu={dropdownMenu.menu}
        />
      )}
    </div>
  );
};

export default MenuWithDropdown;
